import { SBTranslate } from "i18n";
import { ITransferenceOrder } from "domain/Inventory/Models/ITransferenceOrder";
import { ITransferenceOrderSummary } from "domain/Inventory/Models/ITransferenceOrderSummary";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SBSummarization from "views/Commons/SBSummarization";
import { ITransferenceOrderSummarizationProps } from "./models/ITransferenceOrderSummarizationProps";

export const TransferenceOrderSummarization = ({
	summary,
	selectedItems,
}: ITransferenceOrderSummarizationProps) => {
	const { i18n } = useTranslation();

	const sum = (list: ITransferenceOrder[], field: keyof ITransferenceOrder) =>
		list.reduce((acc, item) => acc + ((item[field] as number) || 0), 0);

	const hasSelected = !!selectedItems && selectedItems.length > 0;

	const summarizations = useMemo(
		() => [
			{
				name: SBTranslate("quantity"),
				tip: SBTranslate("quantity"),
				icon: "package",
				color: "darkPurple",
				value: summary?.totalQuantity || 0,
				selectedItems: hasSelected
					? sum(selectedItems!, "quantity")
					: undefined,
			},
		],
		[summary, selectedItems, i18n.language],
	);

	if (!summary || summary.totalCount === 0) return null;

	return <SBSummarization items={summarizations} withShadow />;
};
